import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { Link } from 'react-router-dom';
import Spinner from 'components/Spinner/Spinner';
import './button.css';

export const BUTTON_TYPES = {
    HOLLOW_LIGHT_GREEN: '--hollow-light-green',
    SOLID_LIGHT_GREEN: '--solid-light-green',
    SOLID_LIGHT_GREEN_GRADIENT: '--solid-light-green-gradient',
    SOLID_DARK_GREEN: '--solid-dark-green',
    SOLID_ORANGE_GRADIENT: '--solid-orange-gradient',
    SOLID_ORANGE: '--solid-orange',
    SOLID_WHITE: '--solid-white'
};

export default class Button extends PureComponent {
    static propTypes = {
        btnType: PropTypes.oneOf(Object.keys(BUTTON_TYPES).map((key) => BUTTON_TYPES[key])),
        className: PropTypes.string,
        classNameLink: PropTypes.string,
        classNameDisabled: PropTypes.string,
        route: PropTypes.string,
        routeProps: PropTypes.object,
        label: PropTypes.string,
        isDisabled: PropTypes.bool,
        isProcessing: PropTypes.bool,
        onClick: PropTypes.func,
        children: PropTypes.any,
        debounceTime: PropTypes.number,
        spinnerSize: PropTypes.number,
        style: PropTypes.object
    }

    static defaultProps = {
        className: '',
        classNameDisabled: '',
        classNameLink: '',
        route: null,
        routeProps: null,
        label: '',
        isDisabled: false,
        isProcessing: false,
        debounceTime: 500,
        spinnerSize: 20,
        style: {}
    }

    constructor(props) {
        super(props);

        this.IS_DEBOUNCE = false;
        this.DEBOUNCE_TIMEOUT = null;
    }

    componentWillUnmount() {
        clearTimeout(this.DEBOUNCE_TIMEOUT);
    }

    onClick = (e) => {
        if (this.props.onClick && !this.props.isDisabled && !this.props.isProcessing && !this.IS_DEBOUNCE) {
            if (this.props.debounceTime) {
                this.IS_DEBOUNCE = true;
            }

            this.props.onClick(e);

            if (this.props.debounceTime) {
                this.DEBOUNCE_TIMEOUT = setTimeout(this.debounce, this.props.debounceTime);
            }
        }
    }

    debounce = () => {
        this.IS_DEBOUNCE = false;
    }

    render() {
        const {
            btnType, className, classNameDisabled, classNameLink, route, style,
            routeProps, label, isDisabled, isProcessing, children, spinnerSize
        } = this.props;

        return (
            <span
                className={`Button ${btnType ? `Button${btnType}` : ''} ${isDisabled ? `Button--disabled ${classNameDisabled}` : ''} ${className}`}
                style={style}
                onClick={this.onClick}>
                {isProcessing
                    ? <Spinner size={spinnerSize} />
                    : route
                        ? <Link
                            className={`Button__link ${classNameLink}`}
                            to={{
                                pathname: route,
                                state: routeProps
                            }}>
                            {children ? children : label}
                        </Link>
                        : children
                            ? children
                            : label
                }
            </span>
        );
    }
}
